import React from 'react';
import { Box, Card, CardContent, Avatar, Typography, IconButton, Chip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const UserCard = ({ name, avatarIcon, avatarColor, buttonIcon, buttonColor, buttonOnClick, extraContent, isCritic, onCardClick }) => (
  <Card onClick={onCardClick}>
    <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Avatar
        alt={name}
        sx={{ bgcolor: avatarColor? avatarColor : isCritic ? 'secondary.main' : '', width: 48, height: 48, mr: 2 }}
      >
        {avatarIcon? avatarIcon : isCritic ? <StarIcon /> : name.split(' ').map(n => n[0]).join('')}
      </Avatar>
      <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <Typography variant="subtitle1" noWrap>
            {name} 
          </Typography>
          {isCritic && <Chip variant="outlined" color="secondary" size="small" label="Experto" sx={{ml:1}} />}
        </Box>
        <Typography variant="body2" color="textSecondary" noWrap>
          {extraContent}
        </Typography>
      </Box>
      <IconButton color={buttonColor} onClick={buttonOnClick} sx={{ ml: 1 }}>
        {buttonIcon}
      </IconButton>
    </CardContent>
  </Card>
);

export default UserCard;
